// Döntési gyakorló (/gyakorlo). A szintbeosztás NEM itt van: az adatbázisban,
// a gyakorlo_helyzetek.min_szint oszlopban (a szerver dönt, kód nélkül állítható).

// A modulkártyák, amelyek alatt a gyakorló linkje megjelenik (Kripto Start):
// 13. Az első kereskedésed, 14. Alakzatok és Kereskedési Stratégiák.
export const GYAKORLO_MODULE_IDS = [
  '9b6e7b60-cd6a-4503-807d-d8f5135c0569',
  '02f86e47-fe6f-4d5c-b2be-0b8481bf51a7',
];

// A PDF-változat (PRO segédlet), a get-resource-url-en át (személyes példány).
export const GYAKORLO_PDF = { slug: 'mi-tortent-utana', fajl: 'P2_mi_tortent_utana_sotet.pdf' };
